<div *ngIf="isPermissionLoaded" class="container">
  <h1 class="page-title">
    <span class="icon"><i class="fas fa-money-bill-transfer"></i></span>{{ 'Menu.Menu.ExchangeRate' | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'ExchangeRateNew.New' | translate }}" [selected]="isSearchFormOpen">
        <form [formGroup]="addForm">
          <div class="p-fluid formgrid grid">
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ExchangeRateNew.ExchangeType' | translate }}</label>
              <div class="col-8 item">
                <p-dropdown
                  formControlName="rateType"
                  [filter]="true"
                  [options]="dailyTypeOptions"
                  [(ngModel)]="dailyRate.rateType"
                  [disabled]="true"
                ></p-dropdown>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"
                ><span class="requiredStart">*</span>{{ 'ExchangeRateNew.ExchangeDate' | translate }}</label
              >
              <div class="col-8 item">
                <p-calendar
                  dataType="string"
                  dateFormat="yy/mm/dd"
                  [class]="
                    submitted && f.dateDtTimeZone.errors
                      ? ['ng-invalid', 'ng-dirty']
                      : []
                  "
                  formControlName="dateDtTimeZone"
                  [(ngModel)]="dailyRate.dateDtTimeZone"
                ></p-calendar>
                <small
                  *ngIf="submitted && f.dateDtTimeZone.errors"
                  class="errors"
                >
                  <div
                    *ngIf="f.dateDtTimeZone.errors.required"
                    class="p-invalid"
                  >
                  {{ 'Common.Button.Required' | translate }}
                  </div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"
                ><span class="requiredStart">*</span>{{ 'ExchangeRateNew.OriginExchangeRate' | translate }}</label
              >
              <div class="col-8 column-value">
                <p-dropdown
                  formControlName="fromCurrency"
                  [filter]="true"
                  [options]="currencyOptions"
                  [(ngModel)]="dailyRate.fromCurrency"
                ></p-dropdown>
                <small
                  *ngIf="submitted && f.fromCurrency.errors"
                  class="errors"
                >
                  <div *ngIf="f.fromCurrency.errors.required" class="p-invalid">
                    {{ 'Common.Button.Required' | translate }}
                  </div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"
                ><span class="requiredStart">*</span>{{ 'ExchangeRateNew.ConversionRate' | translate }}</label
              >
              <div class="col-8 column-value">
                <p-dropdown
                  formControlName="toCurrency"
                  [filter]="true"
                  [options]="currencyOptions"
                  [(ngModel)]="dailyRate.toCurrency"
                ></p-dropdown>
                <small *ngIf="submitted && f.toCurrency.errors" class="errors">
                  <div *ngIf="f.toCurrency.errors.required" class="p-invalid">
                    {{ 'Common.Button.Required' | translate }}
                  </div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"
                ><span class="requiredStart">*</span>{{ 'ExchangeRateNew.ExchangeRate' | translate }}</label
              >
              <div class="col-8 item">
                <p-inputNumber
                  [class]="
                    submitted && f.rate.errors ? ['ng-invalid', 'ng-dirty'] : []
                  "
                  formControlName="rate"
                  [(ngModel)]="dailyRate.rate"
                  mode="decimal"
                  [minFractionDigits]="5"
                  [maxFractionDigits]="5"
                  [maxlength]="15"
                ></p-inputNumber>
                <small *ngIf="submitted && f.rate.errors" class="errors">
                  <div *ngIf="f.rate.errors.required" class="p-invalid">
                    {{ 'Common.Button.Required' | translate }}
                  </div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"
                ><span class="requiredStart">*</span>{{ 'ExchangeRateNew.ExchangeRateRange' | translate }}</label
              >
              <div class="col-8 item">
                <p-calendar
                  dataType="string"
                  view="month"
                  dateFormat="yymm"
                  [yearRange]="yearRange"
                  [yearNavigator]="true"
                  [class]="
                    submitted && f.rateYM.errors
                      ? ['ng-invalid', 'ng-dirty']
                      : []
                  "
                  formControlName="rateYM"
                  [(ngModel)]="dailyRate.rateYM"
                ></p-calendar>
                <small *ngIf="submitted && f.rateYM.errors" class="errors">
                  <div *ngIf="f.rateYM.errors.required" class="p-invalid">
                    {{ 'Common.Button.Required' | translate }}
                  </div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ExchangeRateNew.IsValid' | translate }}</label>
              <div class="col-8 item">
                <p-radioButton
                  formControlName="isActivated"
                  name="isActivated"
                  value="1"
                  label="Y"
                  [(ngModel)]="dailyRate.isActivated"
                ></p-radioButton>
                <p-radioButton
                  formControlName="isActivated"
                  name="isActivated"
                  value="0"
                  label="N"
                  [(ngModel)]="dailyRate.isActivated"
                  class="ml-2"
                ></p-radioButton>
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Save' | translate }}"
                (click)="saveBtn($event)"
                class="mr-2"
              ></button>
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.ReturnWithoutSaving' | translate }}"
                (click)="goToLastPage()"
                class="mr-2"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
  </p-card>
</div>
